import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import EventLogDTO from '../../adapters/dto/eventLog/EventLogDTO';
import Layout from '../../components/layout/Layout';
import Details from './components/Details';
import SearchBody from './components/SearchBody';

function AuditLog() {
  const [selected, setSelected] = useState<EventLogDTO>();

  return (
    <Layout>
      <Box sx={{ padding: '0 20px 20px 20px', display: 'flex' }}>
        <Box sx={{ paddingRight: '40px' }}>
          <Typography variant="h4">Audit Log</Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ width: '70%' }}>
          <SearchBody selected={selected} setSelected={setSelected} />
        </Box>
        <Box sx={(theme) => ({ width: '30%', paddingLeft: theme.spacing(4) })}>
          <Details eventLog={selected} />
        </Box>
      </Box>
    </Layout>
  );
}

export default AuditLog;
